export const generateFormName = (entity: string, id: number): string => `COMPLAINT_${entity}_${id}`;
